import {
    GET_ALL_LOCATIONS,
    GET_LOCATION,
    CALOCA_LOADING,
    ADD_LOCATION
  } from "../actions/ExtracurricularCoursesAdminLocationsAction";
  
  
  const initialState = {
    locationslist: [],
    location: [],
    loading: false,
    add: false,
  };
  
  const UserAdmin = function(state = initialState, action) {
    switch (action.type) {
        case CALOCA_LOADING: {
          return {
            ...state,
            loading: true,
            add: false
          };
        }
        case GET_ALL_LOCATIONS: {
            return{
                ...state,
                locationslist : [...action.data],
                location:[],
                loading: false,
                add : false,
            }
        }
        case GET_LOCATION: {
          return{
              ...state,
              location : [...action.data],
              loading: false
          }
        }
        case ADD_LOCATION: {
          return {
            ...state,
            location:[],
            add : true,
            loading: false  
          };
        }
        default: {
            return state;
          }
        }
  }
  
  export default UserAdmin;
  